
import LogoutButton from '@/components/LogoutButton.vue'
import { useAuth0 } from '@auth0/auth0-vue';

export default {
    name: 'SideBar',
    components: {
        LogoutButton
    },
    setup() {
        const { user } = useAuth0();
        console.log(user.value)
        return {
            user: user.value
        }
    },
}
